import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'typed-values'
const verb = 'get'

export default class OspreyTypedValueGet extends BaseAction {
    constructor() {
        const id = '2fba5614-559d-45a3-8a24-f7b4b2ea1a8e'
        const path = `/${resource}`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getTypedValues(params) {
        this.params = Object.assign({
            fields: 'id,type,ownerOrn,value'
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/typed-value/typed-values.js